import type { CSSObject } from '@mui/material'

const dateRangePicker: CSSObject = {
  '.Mui-DateRangePicker': {
    position: 'absolute !important',
  },
}

export default dateRangePicker
